import React from 'react';
import { PAYPAL_THEME, CaptionText } from '@paypalcorp/pp-react';
import { StyleSheet, css } from 'aphrodite';
import MessageWithHTML from './MessageWithHtml';

const { sysColorUnselectedContrast } = PAYPAL_THEME;

const styles = StyleSheet.create({
  disclaimerWrapper: {
    maxWidth: 415,
    margin: '24px auto 0',
  },
  disclaimer: {
    margin: 'auto',
  },
});

export default function VoucherFlowDisclaimer() {
  return (
    <div className={`voucher-disclaimer ${css(styles.disclaimerWrapper)}`}>
      <CaptionText
        style={{
          color: sysColorUnselectedContrast,
        }}
      >
        <MessageWithHTML id="landing.voucher.legal" />
      </CaptionText>
    </div>
  );
}
